// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"A6qjp3","hidden":"g9Pxbv","clampContainer":"VjuNuP","clamp":"b9J4jH"};